import React, {useEffect, useState} from 'react'
import {SERVICE_MENU_ITEMS, SideNavBar} from './SideNavBar'
import * as ReactBootstrap from 'react-bootstrap'
import BurgerMenu from 'react-burger-menu'
import {useSelector} from 'react-redux'

const styles = {
    bmBurgerButton: {
        position: 'fixed',
        width: '36px',
        height: '30px',
        left: '18px',
        top: '70px',
        marginBottom: '60px',
    },
    bmBurgerBars: {
        background: '#373a47',
    },
    bmBurgerBarsHover: {
        background: '#a90000',
    },
    bmCrossButton: {
        height: '24px',
        width: '24px',
    },
    bmCross: {
        background: '#bdc3c7',
    },
    bmMenuWrap: {
        position: 'fixed',
        height: '100%',
    },
    bmMenu: {
        background: '#373a47',
        padding: '0',
        fontSize: '1.15em',
    },
    bmMorphShape: {
        fill: '#373a47',
    },
    bmItemList: {
        color: '#b8b7ad',
    },
    bmItem: {
        display: 'inline-block',
    },
    bmOverlay: {
        background: 'rgba(0, 0, 0, 0.3)',
    },
}

export const MobileDeviceLayout = ({children}) => {
    const {user} = useSelector((state) => state.auth)
    const [currentMenu] = useState('slide')
    const [currentMenuSide] = useState('left')
    const [isMenuOpen] = useState(false)
    const [menu, setMenu] = useState()
    useEffect(() => {
        if (user.department === "service") {
            const temp = SERVICE_MENU_ITEMS
            setMenu(temp.filter((x) => !x.roles || x.roles.includes(user.role)))
        }
    }, []);


    const Menu = BurgerMenu[currentMenu]

    return (
        <div className="container-fluid vh-100">
            <ReactBootstrap.Row id="outer-container">
                <Menu
                    styles={styles}
                    isOpen={isMenuOpen}
                    pageWrapId={'page-wrapper'}
                    outerContainerId={'outer-container'}
                    right={currentMenuSide === 'right'}
                >
                    <SideNavBar menu={menu} brand="easeOn"/>
                </Menu>

                <ReactBootstrap.Col
                    style={{padding: '0px'}}
                    id="page-wrapper"
                    md="12"
                >
                    {children}
                </ReactBootstrap.Col>
            </ReactBootstrap.Row>
        </div>
    )
}
